import { logofaded, coverImage } from "../../assets/images/images";
import Footer from "../../components/Footer/Footer";
import Topbar from "../../components/Topbar/Topbar";
import "./register.css";

import React, { useState } from "react";
import API from "../../API";
import Joi from "joi";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from 'react-i18next';
import {
  FaUser, FaEnvelope, FaPhone, FaLock, FaEye, FaEyeSlash, FaUserPlus,
  FaExclamationCircle, FaPlaneDeparture, FaHotel, FaPassport, FaTicketAlt, FaMapMarkedAlt
} from "react-icons/fa";
import PhoneField from "../../components/PhoneField/PhoneField";

export default function Register() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    if (i18n.language === lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    window.location.reload();
  };
  const isFr = i18n.language === 'fr';
  const isAr = i18n.language === 'ar';
  const isRTL = isAr;
  const [seepsw, setSeepsw] = useState(false);
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors([]);
  };

  const customTLDs = ['com', 'net', 'org', 'io', 'co', 'us'];

  const schema = Joi.object({
    firstname: Joi.string().min(1).required().label(t("register.firstname_label")),
    lastname: Joi.string().min(1).required().label(t("register.lastname_label")),
    phone: Joi.string().pattern(/^\+[1-9]\d{6,14}$/).required().label(t("register.phone_label")),
    email: Joi.string().email({ tlds: { allow: customTLDs } }).required().label(t("register.email_label")),
    password: Joi.string().min(8).required().label(t("register.password_label"))
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error } = schema.validate(formData, { abortEarly: false });
    if (error) {
      const messages = error.details.map(detail => detail.message);
      setErrors(messages);
      return;
    }

    setLoading(true);

    try {
      const response = await API.post('/auth/signup/user', formData);
      if (response.status === 201) {
        window.location.href = 'login';
      }
    } catch (error) {
      console.error("Signup error:", error);
      setErrors([t("register.error_message")]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Page_register" dir={isRTL ? "rtl" : "ltr"}>
      <Topbar />

      <div className="auth-langbar" role="group" aria-label="language">
        <button type="button" className={`auth-langbtn ${isFr ? 'active' : ''}`} onClick={() => changeLanguage('fr')} aria-pressed={isFr}>FR</button>
        <button type="button" className={`auth-langbtn ${isAr ? 'active' : ''}`} onClick={() => changeLanguage('ar')} aria-pressed={isAr}>AR</button>
      </div>

      <main className="auth-shell">
        <aside
          className="auth-brand"
          style={{ backgroundImage: `url(${coverImage})` }}
        >
          <div className="auth-brand__scrim" />
          <div className="auth-brand__content">
            <div className="auth-brand__row">
              <div className="auth-brand__logo">
                <img src={logofaded} alt="Protour" />
              </div>
              <h2 className="auth-brand__heading">{t("register.brand_heading")}</h2>
            </div>
            <p className="auth-brand__sub">{t("register.brand_sub")}</p>

            <ul className="auth-features">
              <li>
                <span className="auth-features__ico"><FaHotel /></span>
                <div>
                  <strong>{t("register.feature_hotels_title")}</strong>
                  <span>{t("register.feature_hotels_sub")}</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaPlaneDeparture /></span>
                <div>
                  <strong>{t("register.feature_voyages_title")}</strong>
                  <span>{t("register.feature_voyages_sub")}</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaPassport /></span>
                <div>
                  <strong>{t("register.feature_visa_title")}</strong>
                  <span>{t("register.feature_visa_sub")}</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaMapMarkedAlt /></span>
                <div>
                  <strong>{t("register.feature_discover_title")}</strong>
                  <span>{t("register.feature_discover_sub")}</span>
                </div>
              </li>
            </ul>
          </div>
        </aside>

        <section className="auth-form-wrap">
          <div className="auth-card">
            <div className="auth-card__head">
              <span className="auth-pill"><span className="auth-pill__dot"><FaUserPlus /></span> {t("register.pill")}</span>
              <h1 className="auth-card__title">{t("register.title")}</h1>
              <p className="auth-card__sub">{t("register.card_sub")}</p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-grid">
                <div className="auth-field">
                  <label className="auth-label">
                    <FaUser className="auth-label__ico" />
                    <span>{t("register.firstname_label")}</span>
                  </label>
                  <input
                    className="auth-input"
                    type="text"
                    placeholder={t("register.firstname_placeholder")}
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="auth-field">
                  <label className="auth-label">
                    <FaUser className="auth-label__ico" />
                    <span>{t("register.lastname_label")}</span>
                  </label>
                  <input
                    className="auth-input"
                    type="text"
                    placeholder={t("register.lastname_placeholder")}
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="auth-field">
                  <label className="auth-label">
                    <FaPhone className="auth-label__ico" />
                    <span>{t("register.phone_label")}</span>
                  </label>
                  <PhoneField
                    name="phone"
                    value={formData.phone}
                    onChange={(v) => {
                      setFormData((prev) => ({ ...prev, phone: v }));
                      setErrors([]);
                    }}
                    required
                  />
                </div>

                <div className="auth-field">
                  <label className="auth-label">
                    <FaEnvelope className="auth-label__ico" />
                    <span>{t("register.email_label")}</span>
                  </label>
                  <input
                    className="auth-input"
                    placeholder={t("register.email_placeholder")}
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="auth-field auth-field--full">
                  <label className="auth-label">
                    <FaLock className="auth-label__ico" />
                    <span>{t("register.password_label")}</span>
                  </label>
                  <div className="auth-input-group">
                    <input
                      className="auth-input"
                      placeholder={t("register.password_placeholder")}
                      type={seepsw ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      className="auth-input-action"
                      onClick={() => setSeepsw((s) => !s)}
                      aria-label="toggle password"
                    >
                      {seepsw ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
              </div>

              {errors.length > 0 && (
                <div className="auth-banner auth-banner--err">
                  <FaExclamationCircle />
                  <div>
                    {errors.map((err, i) => (<p key={i}>{err}</p>))}
                  </div>
                </div>
              )}

              <button type="submit" className="auth-btn auth-btn--primary" disabled={loading}>
                {loading ? (
                  <ClipLoader color={"#fff"} loading={loading} size={18} />
                ) : (
                  <>
                    <FaUserPlus /> {t("register.register_button")}
                  </>
                )}
              </button>
            </form>

            <div className="auth-divider"><span>{t("register.or")}</span></div>

            <p className="auth-foot">
              {t("register.login_link")} <a className="auth-link auth-link--strong" href="/login">{t("register.login_button")}</a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
